import { StructuredTextDocument } from 'react-datocms'
import { Upload } from 'datocms-plugin-sdk'

export enum CellType {
  StructuredText = 'structuredText',
  Image = 'image'
}

export type CellStructuredText = {
  id: string
  type: CellType.StructuredText
  value: StructuredTextDocument
}

export type CellStructuredTextEditing = {
  id: string
  type: CellType.StructuredText
  isBold: boolean
  isItalic: boolean
  value: string
}

export type CellImage = {
  id: string
  type: CellType.Image
  value: Upload
}

export type Cell = CellStructuredText | CellImage

export type EditingCell = CellStructuredTextEditing | CellImage

export type TableOptions = {
  mainColumn: number
  mainRow: number
}

export type TableData = Array<Array<Cell>>

export type Table = {
  title?: string
  options: TableOptions
  data: TableData
}
